// src/lib/gtm.js
// Minimal helpers to push events into Google Tag Manager's dataLayer.
// These events are then mapped to Google Ads conversions via GTM.

/**
 * Push a GTM event into the dataLayer.
 *
 * @param {string} eventName - dataLayer event name (e.g. 'tp_signup')
 * @param {Record<string, any>} [data] - additional payload (avoid PII)
 * @param {{ onceKey?: string }} [opts] - optional de-duplication key stored in localStorage
 */
export function pushGtmEvent(eventName, data = {}, opts = {}) {
  try {
    if (typeof window === 'undefined') return false;
    if (!eventName) return false;

    // Optional de-dup (prevents double counting on refresh / re-renders)
    const onceKey = opts?.onceKey;
    if (onceKey && typeof localStorage !== 'undefined') {
      const k = `tresopilot_gtm_once:${onceKey}`;
      if (localStorage.getItem(k)) return false;
      localStorage.setItem(k, '1');
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: String(eventName),
      ...data,
    });

    return true;
  } catch (_) {
    return false;
  }
}

/**
 * Derive which Google Ads conversion event to fire from checkout context.
 * Returns one of: tp_pack_60j_purchase, tp_sub_plus, tp_sub_pro, or null.
 */
export function gadsEventFromCheckout({ plan, type } = {}) {
  const p = String(plan || '').toLowerCase();
  const t = String(type || '').toLowerCase();

  if (t === 'pack' || p.includes('pack')) return 'tp_pack_60j_purchase';
  if (p === 'plus') return 'tp_sub_plus';
  if (p === 'pro') return 'tp_sub_pro';

  return null;
}
